import React, { useState, useEffect } from 'react';
import '../assets/fontes/fontes.css';
import '../styles/Orion.css';
import '../styles/OrionComponentes.css';
import { janelaExpandida, copiarTexto } from '../services/plataforma';
import { PanelHead } from '../components/ui';
import Icon from '../components/Icon';

// ─────────────────────────────────────────────────────────────────────────────
// Ticket formalizado em janela própria (hash '#expandido').
//
// É o antigo expanded.html, agora parte do mesmo bundle React. Serve para o
// operador ler o ticket inteiro numa janela grande e copiar rápido:
//   Ctrl+E copia o ticket · Ctrl+Q copia a mensagem de conclusão · Esc fecha.
//
// Não usa o OrionContext de propósito: é uma janela avulsa, sem sessão, sem
// barra lateral e sem nada que dependa do estado do app principal.
// ─────────────────────────────────────────────────────────────────────────────

export default function TicketExpandido() {
  const [dados, setDados] = useState({ text: '', conclusionMsg: '', subject: '', classifications: null });
  const [aviso, setAviso] = useState('Pronto');

  // Os dados chegam por IPC no desktop; na web, pelo sessionStorage.
  useEffect(() => janelaExpandida.aoReceberDados(d => setDados(d || {})), []);

  const piscar = (msg) => {
    setAviso(msg);
    setTimeout(() => setAviso('Pronto'), 2200);
  };

  // O aviso espera a cópia acontecer: dizer "copiado" antes de saber se
  // copiou faz o operador colar o conteúdo antigo sem desconfiar.
  const copiarTicket = async () => {
    if (!dados.text) return;
    piscar(await copiarTexto(dados.text) ? 'Ticket copiado!' : 'Não consegui copiar.');
  };

  const copiarConclusao = async () => {
    if (!dados.conclusionMsg) return;
    piscar(await copiarTexto(dados.conclusionMsg) ? 'Conclusão copiada!' : 'Não consegui copiar.');
  };

  useEffect(() => {
    const aoTeclar = (e) => {
      if (e.ctrlKey && (e.key === 'e' || e.key === 'E')) copiarTicket();
      if (e.ctrlKey && (e.key === 'q' || e.key === 'Q')) copiarConclusao();
      if (e.key === 'Escape') window.close();
    };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dados]);

  const c = dados.classifications;
  const temMeta = dados.subject || c;

  return (
    <div className="orion" data-theme="dark">
      <div className="app-shell">
        <header className="topbar">
          <div className="topbar-title">
            <Icon name="file-text" size={17} /> Ticket formalizado
          </div>
          <div className="topbar-right">
            <button className="btn btn-ghost btn-sm" onClick={copiarTicket}>
              <Icon name="copy" size={13} /> Copiar <span className="atalho">Ctrl+E</span>
            </button>
            <button className="btn btn-ghost btn-sm" onClick={copiarConclusao}>
              <Icon name="check" size={13} /> Conclusão <span className="atalho">Ctrl+Q</span>
            </button>
          </div>
        </header>

        <main className="content">
          {temMeta && (
            <div className="panel">
              <PanelHead titulo={dados.subject || 'Sem assunto'} sub="classificação sugerida" />
              <div className="sol-body">
                <div>
                  <div className="fld-label">Classificação</div>
                  <div className="fld-value">{c?.classificacao || '—'}</div>
                </div>
                <div>
                  <div className="fld-label">Ocorrência</div>
                  <div className="fld-value">{c?.ocorrencia || '—'}</div>
                </div>
                <div>
                  <div className="fld-label">Criticidade</div>
                  <div className="fld-value">{c?.criticidade || '—'}</div>
                </div>
              </div>
            </div>
          )}

          <div className="panel">
            <PanelHead titulo="Texto do ticket" sub={aviso} />
            <div className="doc-preview" style={{ maxHeight: '58vh', overflowY: 'auto' }}>
              {dados.text || '—'}
            </div>
          </div>

          <div className="acoes-fim">
            <button className="btn btn-primary" onClick={() => window.close()}>Fechar</button>
          </div>
        </main>
      </div>
    </div>
  );
}
